// Notification copy resolver for socket events
export const TRIGGER_LABELS = {
  new_chat: {
    label: 'New Chat',
    description: 'New chat in one of your groups',
  },
  chat_assigned: {
    label: 'Chat Assigned',
    description: 'Chat assigned to you or your team',
  },
  chat_message: {
    label: 'Chat Message',
    description: 'New message in active chat',
  },
  new_ticket: {
    label: 'New Ticket',
    description: 'New ticket created',
  },
  ticket_assigned: {
    label: 'Ticket Assigned',
    description: 'Ticket assigned to you',
  },
  ticket_message: {
    label: 'Ticket Message',
    description: 'New message in ticket',
  },
  ticket_status_changed: {
    label: 'Ticket Status Changed',
    description: 'Ticket status updated',
  },
  kb_article_pending_review: {
    label: 'Article Pending Review',
    description: 'KB article submitted for review',
  },
  kb_article_published: {
    label: 'Article Published',
    description: 'KB article was published',
  },
  kb_article_archived: {
    label: 'Article Archived',
    description: 'KB article was archived',
  },
  kb_feedback_received: {
    label: 'New Comment',
    description: 'New feedback on KB article',
  },
  kb_feedback_assigned: {
    label: 'Comment Assigned',
    description: 'Feedback assigned to you',
  },
};

export function resolveNotificationCopy(type, ctx = {}) {
  const labels = TRIGGER_LABELS[type];
  switch (type) {
    case 'new_chat':
      return {
        title: 'New chat',
        body:
          ctx.visitorName != null
            ? `New chat from ${ctx.visitorName}`
            : labels?.description || 'New chat in one of your groups',
      };
    case 'chat_assigned':
      return {
        title: 'Chat assigned',
        body: ctx.visitorName
          ? `Chat with ${ctx.visitorName} assigned to you`
          : labels?.description || 'Chat assigned to you or your team',
      };
    case 'chat_message':
      return {
        title:
          ctx.count > 1 ? 'New messages from visitor' : 'New chat message',
        body: ctx.messagePreview || labels?.description || '',
      };
    case 'new_ticket':
      return {
        title: 'New ticket',
        body: ctx.subject
          ? `${ctx.subject}${ctx.customerName ? ` — ${ctx.customerName}` : ''}`
          : labels?.description || '',
      };
    case 'ticket_assigned':
      return {
        title: 'Ticket assigned',
        body: ctx.subject || labels?.description || '',
      };
    case 'ticket_message':
      return {
        title: 'Ticket message',
        body: ctx.messagePreview || ctx.subject || labels?.description || '',
      };
    case 'ticket_status_changed':
      if (ctx.newStatus === 'solved') {
        return {
          title: 'Ticket solved',
          body: ctx.subject || 'Assigned ticket marked solved',
        };
      }
      return {
        title: 'Ticket status changed',
        body: ctx.subject
          ? `${ctx.subject} — ${ctx.newStatus || 'updated'}`
          : labels?.description || '',
      };
    case 'kb_article_pending_review':
      return {
        title: 'Article submitted',
        body:
          ctx.articleTitle != null
            ? `"${ctx.articleTitle}" pending editor review`
            : labels?.description || '',
      };
    case 'kb_article_published':
      return {
        title: 'Article published',
        body:
          ctx.articleTitle != null
            ? `"${ctx.articleTitle}" was published`
            : labels?.description || '',
      };
    case 'kb_article_archived':
      return {
        title: 'Article archived',
        body:
          ctx.articleTitle != null
            ? `"${ctx.articleTitle}" was archived`
            : 'KB article archived',
      };
    case 'kb_feedback_received':
      return {
        title: 'New comment',
        body: ctx.body || labels?.description || '',
      };
    case 'kb_feedback_assigned':
      return {
        title: 'Comment assigned',
        body: labels?.description || '',
      };
    default:
      return {
        title: ctx.title || type,
        body: ctx.body || '',
      };
  }
}

export function showBrowserNotification(type, metadata = {}, options = {}) {
  if (!("Notification" in window)) {
    console.warn("Browser notifications not supported");
    return;
  }

  if (Notification.permission !== "granted") {
    console.warn("Notification permission not granted");
    return;
  }

  const copy = resolveNotificationCopy(type, metadata);
  const { title, body } = copy;

  const notification = new Notification(title, {
    body,
    icon: options.icon || "/favicon.ico",
    badge: options.badge || "/favicon.ico",
    tag: options.tag || type,
    requireInteraction: options.requireInteraction || false,
    silent: options.silent || false,
    ...options,
  });

  if (options.onClick) {
    notification.onclick = options.onClick;
  }

  if (options.onClose) {
    notification.onclose = options.onClose;
  }

  return notification;
}
